import * as React from 'react'
import * as st from './badge.module.scss'
import { safeBoolean } from '../../utils/utils';

export interface IXRayBadgeProps {
  isXRay?: boolean
}

//TODO: AVWebDetailPage-2972
export const XRay = ({ isXRay }: IXRayBadgeProps) => (
  safeBoolean(isXRay) &&
  (<span className={st.borderedTextBadge}>
    <span data-automation-id="x-ray-badge">X-Ray</span>
  </span>) || null
)
